// Header Trasparent //
var transperentElment = document.querySelector(".allow-transparent-header");
var header = document.querySelector(".header-wrapper");
var announcement_bar = document.querySelector(".announcement-bar-section");
if(transperentElment){
  header.classList.add("allow-transparent-header");
  announcement_bar.classList.add("allow-transparent-header");
}
// Get the height of the announcement bar section
var announceheight = document.querySelector(".announcement-bar-section").offsetHeight;

// Find the menu drawer and set its "top" style
var menuDrawer = document.querySelector(".header-wrapper.allow-transparent-header:not(.scrolled-past-header) .menu-drawer");
if (menuDrawer) {
  menuDrawer.style.top = -announceheight + "px";
}
 

// PASSWORD SHOW AND HIDE start
class ShowPassword extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.show_password.bind(this));
  }

  show_password(event) {
    event.preventDefault();
    this.closest('.field').querySelector('input').setAttribute('type', this.closest('.field').querySelector('input').getAttribute('type') === 'password' ? 'text' : 'password');
    this.classList.toggle('show-password');
  }
}

 // <show-password>
 //   <a href="javascript:void(0);"class="close-icon">text</a>
 // </show-password>

customElements.define('show-password', ShowPassword);
// PASSWORD SHOW AND HIDE END

// accordions js start
function faq_taggol() {
  const accordions = document.querySelectorAll("[js-acc-item]");
  const openAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.add("active");
    const scrollcontent = accordion.getAttribute("js-acc-single-trigger-scroll") || null;
    content.style.maxHeight = 'max-content';
  };
  
  const closeAccordion = (accordion) => {
  // console.log("closeAccordion", accordion)
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.remove("active");
    if(content){
      content.style.maxHeight = null;
    }
  };
  
  accordions.forEach((accordion) => {
    const intro = accordion.querySelector("[js-acc-single-trigger]");
    const content = accordion.querySelector("[js-acc-single-content]");
    const acc_main = accordion.closest('[data-tab-acc-main-content]') || null;
    if(intro){
        intro.onclick = (e) => {
          if (content.style.maxHeight) {
            closeAccordion(accordion);
          } else {
            if(acc_main){
              console.log("acc_main")
              const main_accodin = acc_main.querySelectorAll("[js-acc-item]");
              main_accodin.forEach((accordion) => closeAccordion(accordion));
               openAccordion(e.target.closest('[js-acc-item]'));
            }else{
                if (accordion.classList.contains("active")){
                                 closeAccordion(accordion)
                }else{
                      openAccordion(e.target.closest('[js-acc-item]'));
                }

               // console.log("accordion", accordion)
               // openAccordion(e.target.closest('[js-acc-item]'));
            }
            
          }
        };
    }
  });   
}

// accordions js end
// ==== menu hover Js======

function collection_filter(){
     const open_buttons = document.querySelectorAll("[dara-filter-open-cust]");
  if(open_buttons){
        open_buttons.forEach((button) => {
          button.addEventListener("click", (e) => {
             e.preventDefault();
               button.closest('#FacetFiltersForm').querySelector("[data-filter-main-blocks]").classList.toggle('show-cust-filter');
                 document.body.classList.toggle('open-cust-filter');
         });
        });
  }
}




const Handle = {};

function initializeVariantSelectors() {
    const MainDiv = document.querySelector('#rbr-container-element-true');
    console.log(MainDiv);
    if (MainDiv) {
        const ChildDIV = MainDiv.querySelectorAll('[class^="Accordion_panel_"]');
        console.log("ChildDIV", ChildDIV)
        // --- First ClickDiv Logic ---
        const ClickDivFind = ChildDIV[0];
        if (ClickDivFind) {
            const ClickDiv = ClickDivFind.querySelectorAll('[class^="variantSelector_container"]') || null;
            // console.log("ClickDiv",ClickDiv)
            if (ClickDiv.length > 0) {
                function FhandleEvent() {
                    document.body.classList.add("loading_popup_open");
                    let currentElement = this;
                    const parents = [];

                    while (currentElement.parentNode) {
                        currentElement = currentElement.parentNode;
                        parents.push(currentElement);
                    }

                    const targetParent = parents.find(parent =>
                        parent.classList && parent.classList.toString().includes('style_productDetail_')
                    );
                    // console.log("targetParent",targetParent)

                    //   const imgDIV = parents.find(IMGget =>
                    //       IMGget.classList && IMGget.classList.toString().includes('style_productContainer_')
                    //   );
                    // console.log("imgDIV",imgDIV)

                    //     var img = imgDIV.querySelector('[class^="style_productImage_"]');
                    //     console.log("img",img)
                    //     if (img) {
                    //         var BGstyle = window.getComputedStyle(img); // No need for currentStyle
                    //         var BGimg = BGstyle.backgroundImage.slice(4, -1).replace(/"/g, "");


                    //         if (BGimg) {
                    //           const IMGDIV = document.querySelectorAll('[class^="accordionHead_thumbnailContainer_"]');
                    //           const ImgAdd = IMGDIV[0];
                    //            ImgAdd.style.backgroundImage = "url(" + BGimg + ")";
                    //         }
                    //     } 

                    if (targetParent) {
                        const ATag = targetParent.querySelector('a');
                        if (ATag) {
                            const ProHandle = ATag.getAttribute('href').trim();
                            const splitget = ProHandle.split("/");
                            if (document.querySelector('html').getAttribute('lang') == 'de') {
                                formattedValue = splitget[2];
                            } else if (document.querySelector('html').getAttribute('lang') == 'en') {
                                formattedValue = splitget[3];
                            }
                            const titleGet = ATag.innerText;
                            console.log("titleGet", titleGet)

                            const titleDiv = document.querySelector('.style-list-wrap ul');
                            const titleInnerDiv = document.createElement('li');
                            titleInnerDiv.textContent = titleGet;
                            titleDiv.appendChild(titleInnerDiv);

                            // Handle.First_handle = formattedValue;

                            // updateThumbnails();
                        }
                    }
                    document.body.classList.remove("loading_popup_open");
                }

                ClickDiv.forEach(Fselector => {
                    Fselector.addEventListener('click', FhandleEvent);
                });
            }
        }

        // --- Second ClickDiv Logic ---
        const SClickDivFind = ChildDIV[1];
        if (SClickDivFind) {
            const SClickDiv = SClickDivFind.querySelectorAll('[class^="variantSelector_container"]') || null;
            if (SClickDiv.length > 0) {
                console.log("SClickDiv", SClickDiv)

                function ShandleEvent() {
                    document.body.classList.add("loading_popup_open");
                    let currentElement = this;
                    const parents = [];

                    while (currentElement.parentNode) {
                        currentElement = currentElement.parentNode;
                        parents.push(currentElement);
                    }

                    const targetParent = parents.find(parent =>
                        parent.classList && parent.classList.toString().includes('style_productDetail_')
                    );

                    if (targetParent) {
                        const ATag = targetParent.querySelector('a');
                        if (ATag) {
                            const ProHandle = ATag.getAttribute('href').trim();
                            const splitget = ProHandle.split("/");
                            if (document.querySelector('html').getAttribute('lang') == 'de') {
                                formattedValue = splitget[2];
                            } else if (document.querySelector('html').getAttribute('lang') == 'en') {
                                formattedValue = splitget[3];
                            }
                            const titleGet = ATag.innerText;
                            console.log("titleGet", titleGet)

                            const titleDiv = document.querySelector('.style-list-wrap ul');
                            const titleInnerDiv = document.createElement('li');
                            titleInnerDiv.textContent = titleGet;
                            titleDiv.appendChild(titleInnerDiv);

                            // Handle.First_handle = formattedValue;

                            // updateThumbnails();
                        }
                    }
                    document.body.classList.remove("loading_popup_open");
                }

                SClickDiv.forEach(Sselector => {
                    Sselector.addEventListener('click', ShandleEvent);
                });
            }
        }

        // --- Third ClickDiv Logic ---
        const TClickDivFind = ChildDIV[2];
        const TClickDiv = TClickDivFind.querySelectorAll('[class^="variantSelector_container"]') || null;
        if (TClickDiv.length > 0) {
          console.log("TClickDiv",TClickDiv)
            function ThandleEvent() {
                document.body.classList.add("loading_popup_open");
                let currentElement = this;
                const parents = [];

                while (currentElement.parentNode) {
                    currentElement = currentElement.parentNode;
                    parents.push(currentElement);
                }

                const targetParent = parents.find(parent =>
                    parent.classList && parent.classList.toString().includes('style_productDetail_')
                );
                if (targetParent) {
                    const ATag = targetParent.querySelector('a');
                    if (ATag) {
                        const ProHandle = ATag.getAttribute('href').trim();
                        const splitget = ProHandle.split("/");
                        if (document.querySelector('html').getAttribute('lang') == 'de') {
                            formattedValue = splitget[2];
                        } else if (document.querySelector('html').getAttribute('lang') == 'en') {
                            formattedValue = splitget[3];
                        }
                        const titleGet = ATag.innerText;
                        console.log("titleGet", titleGet)

                        const titleDiv = document.querySelector('.style-list-wrap ul');
                        const titleInnerDiv = document.createElement('li');
                        titleInnerDiv.textContent = titleGet;
                        titleDiv.appendChild(titleInnerDiv);

                        // Handle.First_handle = formattedValue;

                        // updateThumbnails();
                    }
                }
                document.body.classList.remove("loading_popup_open");
            }
            TClickDiv.forEach(Tselector => {
                Tselector.addEventListener('change', ThandleEvent);
            });
        }
    }
}

function updateThumbnails() {
    const Alttext = Object.values(Handle).join("/");

    const hideDIV = document.querySelectorAll('.product-media-wrapper .show_img_alt');
    hideDIV.forEach(hideDIVS => {
        hideDIVS.style.display = 'none';
    });

    const targetThumbnails = document.querySelectorAll(`.product-media-wrapper [data-alt="${Alttext}"]`);
    if (targetThumbnails.length > 0) {
        targetThumbnails.forEach(thumb => {
            thumb.style.display = 'block';
        });
    } else {
        const fallbackDIV = document.querySelectorAll('.product-media-wrapper .show_img');
        fallbackDIV.forEach(fallbackDIVS => {
            fallbackDIVS.style.display = 'block';
        });
    }
}


function ALAcheckCatorgy() { 
isALARenderedCategory = setInterval(function () {
 const all_select_var =  document.querySelectorAll('[class^="variantSelector_container"]') || null;
  if(all_select_var.length > 0){
    clearInterval(isALARenderedCategory);
    if (document.body.classList.contains('template_page_bundle')) {
      initializeVariantSelectors();
    }   
  }
  }, 500); 
 } 
  ALAcheckCatorgy(); 

// ========== custom bundle JS




function popup_open_by(){
  if(window.location.search){
      const popup_get = document.querySelector('[data-popup-selecot="'+window.location.search.split('?')[1]+'"]') || null;
      console.log("popup_get",popup_get)
      if(popup_get){

        const targetPosition = popup_get.getBoundingClientRect().top + window.scrollY - 100;

          // Smooth scroll to that position
          window.scrollTo({
            top: targetPosition,
            behavior: "smooth"
          });

           setTimeout(() => {
              popup_get.click();
              window.history.replaceState({}, null, window.location.href.split('?')[0]);
            }, 1000);
          
      }
  }
}


(function() {
  faq_taggol();
  collection_filter();
  popup_open_by();
})();


// document.addEventListener("DOMContentLoaded", function () {
//     const slider = document.querySelector('.store-slider-main .swiper');

//     if (slider) {
//         new Swiper(slider, {
//             loop: false,
//             slidesPerView: 1,
//             spaceBetween: 10,
//             pagination: {
//                 el: '.swiper-pagination',
//                 clickable: true,
//             },
//             breakpoints: {
//                 768: { slidesPerView: 1 },
//                 1024: { slidesPerView: 1 }
//             }
//         });
//     }
// });

lightGallery(document.getElementById('lightgallery'));

const popup_open = document.querySelectorAll('[data-popup-open]') || null;
  if(popup_open){
      popup_open.forEach(b => {
      b.addEventListener("click", (event) => {
        console.log(event)
        event.preventDefault();
           const main_popup = document.querySelector(event.target.hash) || null;
        console.log(main_popup);
          if(!main_popup) return;
                 main_popup.classList.add("open"); 
                 document.body.classList.add("popup_open");
        });
     });
  }  

  const popup_close = document.querySelectorAll('[data-popup-close]') || null;
  if(popup_close){
      popup_close.forEach(b => {
      b.addEventListener("click", (event) => {
        event.preventDefault();
           const main_popup = event.target.closest('[data-poup]') || null;
          if(!main_popup) return;
                 main_popup.classList.remove("open"); 
                 document.body.classList.remove("popup_open");
        });
     });
  } 




const store_link = document.querySelectorAll('[store_link]') || null;
if(store_link){
  store_link.forEach(b => {
    b.addEventListener("click", (event) => {
      const store = b.getAttribute('store_link');
      document.querySelector('.active[store_link]').classList.remove('active')
      b.classList.add('active')
      document.querySelectorAll('[store_name]').forEach(a => {
        a.classList.add('hidden');
      });
      document.querySelector('[store_name="'+ store +'"]').classList.remove("hidden");
      });
   });
}

const selectEl = document.querySelector('select[store_list]');
if(selectEl){
  selectEl.addEventListener('change', function () {
    const selectedValue = this.options[this.selectedIndex].getAttribute('store_name_select');
  
    // Hide all store content blocks
    document.querySelectorAll('[store_name]').forEach(el => {
      el.classList.add('hidden');
    });
  
    // Show the selected one
    const target = document.querySelector(`[store_name="${selectedValue}"]`);
    if (target) {
      target.classList.remove("hidden");
    }
  });
}



